import * as React from "react";
const SvgHomeTable = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <circle cx={20} cy={20} r={20} fill="#DCD2FB" />
    <path
      fill="#874EFF"
      d="M18.495 12.461a1.94 1.94 0 0 1 2.51 0l5.812 4.94a1.94 1.94 0 0 1 .683 1.477v7.726a1.49 1.49 0 0 1-1.49 1.49h-2.385a1.49 1.49 0 0 1-1.49-1.49v-3.875a1.19 1.19 0 0 0-1.187-1.192h-2.396a1.19 1.19 0 0 0-1.187 1.192v3.875a1.49 1.49 0 0 1-1.49 1.49H13.49a1.49 1.49 0 0 1-1.49-1.49v-7.726a1.94 1.94 0 0 1 .683-1.476z"
    />
  </svg>
);
export default SvgHomeTable;